/* eslint-disable complexity */
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-param-reassign */
/* eslint-disable max-lines */
export const overrides = {
  price_level: 'price',
  shipping_level: 'shipping',
  handling_level: 'handling',
  use_dynamic_shipping: '1',
  dsc_version: '2',
  free_shipping: '1',
  catalog_type: 'Auto',
  catalog_source: 'Endeca',
  restrictedZipCode: '1',
  po_box: '1',
}

export const cards = [
  {
    type: 'normal',
    class: 'normalBG',
  },
  {
    type: 'visa',
    class: 'visaBG',
  },
  {
    type: 'masterCard',
    class: 'masterCardBG',
  },
  {
    type: 'americanExpress',
    class: 'americanExpressBG',
  },
  {
    type: 'discover',
    class: 'discoverBG',
  },
  {
    type: 'maestro',
    class: 'maestroBG',
  },
  {
    type: 'jcb',
    class: 'jcbBG',
  },
  {
    type: 'dinersClub',
    class: 'dinersClubBG',
  },
]

export const constPaths = { cart: 'cart', search: 'search' }

// Converting camel case to snake case
export const camelToSnakeCase = data => Object.entries(data)
  .reduce((updatedQueryObject, [key, value]) => {
    const element = Object.entries(value).reduce(
      (snakeCaseObject, [elementKey, elementValue]) => {
        const snakeCaseKey = elementKey
          .split(/(?=[A-Z])/)
          .join('_')
          .toLowerCase()
        snakeCaseObject[`${snakeCaseKey}`] = elementValue
        return snakeCaseObject
      },
      {},
    )
    updatedQueryObject[`${key}`] = element
    return updatedQueryObject
  }, {})

// converting snake case to camel case
export const snakeToCamelCase = data => {
  const convert = matches => matches.toUpperCase().replace('_', '')
  return Object.entries(data).reduce((updatedQueryObject, [key, value]) => {
    const element = Object.entries(value).reduce(
      (camelCaseObject, [elementKey, elementValue]) => {
        const camelCaseKey = elementKey.replace(/([-_][a-z])/g, convert)
        camelCaseObject[`${camelCaseKey}`] = elementValue
        return camelCaseObject
      },
      {},
    )
    updatedQueryObject[`${key}`] = element
    return updatedQueryObject
  }, {})
}

export const getUTC = () => {
  const date = new Date()
  return `${date.getYear() + 1900 || ''}-${date.getMonth() + 1
    || ''}-${date.getDate()} ${date.getUTCHours()}:${date.getUTCMinutes()}:${date.getUTCSeconds()} UTC`
}

export const injectJS = (src, id) => {
  const elem = __BROWSER__ && document.querySelector(`[customid=${id}]`)
  if (!elem) {
    const jsElem = document.createElement('script')
    jsElem.setAttribute('type', 'text/javascript')
    jsElem.setAttribute('customid', id)
    jsElem.setAttribute('src', src)
    jsElem.setAttribute('async', true)
    document.head.appendChild(jsElem)
  }
}

export const importPaymentScripts = (
  PAYPAL_SDK,
  QUADPAY_SDK,
) => {
  if (__BROWSER__ && !window.paypal) {
    injectJS(PAYPAL_SDK, 'paypal')
  }

  if (__BROWSER__ && !window.google) {
    injectJS('https://pay.google.com/gp/p/js/pay.js', 'gpay')
  }

  if (__BROWSER__ && !window.JSEncrypt) {
    injectJS('/static/assets/js/jsencrypt.min.js', 'JSEncrypt')
  }

  if (__BROWSER__ && !window.quadpay) {
    injectJS(QUADPAY_SDK, 'quadpay')
  }
}

export const getProps = (object, keys, defaultVal) => {
  keys = Array.isArray(keys) ? keys : keys.split('.')
  object = object[keys[0]]
  if (object && keys.length > 1) {
    return getProps(object, keys.slice(1))
  }
  return object === undefined ? defaultVal : object
}

export const removeEmptyKeys = element => Object.entries(element || {})
  .reduce((obj, [key, value]) => {
    if (value) return { ...obj, [key]: value }
    return obj
  }, {})

export const isEqual = (a, b) => {
  const first = removeEmptyKeys(a)
  const second = removeEmptyKeys(b)
  const aProps = Object.getOwnPropertyNames(first)
  const bProps = Object.getOwnPropertyNames(second)
  if (aProps.length !== bProps.length) {
    return false
  }
  for (let i = 0; i < aProps.length; i += 1) {
    const propName = aProps[i]
    if (
      (a[propName] || '').toString().toLowerCase()
      !== (b[propName] || '').toString().toLowerCase()
    ) {
      return false
    }
  }
  return true
}

export const CustomAccordionTheme = {
  accordion: {
    border: undefined,
    icons: {
      color: '#333333',
    },
  },
  anchor: {
    color: '#333333',
  },
  box: {
    extend: (props) => `box-shadow: none;
      border-color:${props.borderColor ? props.borderColor : '#E0E0E0'}`,
  },
  button: {
    color: '#2E4787',
    border: {
      radius: '26px',
      color: '#2E4787',
      width: '1px',
    },

    extend: ({ signInButton }) => `
      ${
  signInButton
    ? `&:hover{
              background: #2E4787;
              color: #fff;
            }`
    : ''
}
      box-shadow: none;
      `,
    padding: {
      vertical: '12px',
      horizontal: '24px',
    },
  },
}

export const CustomAccordionThemeCheckoutItems = {
  accordion: {
    border: undefined,
    icons: {
      color: 'white',
    },
  },
  anchor: {
    color: '#333333',
  },

  button: {
    color: '#2E4787',
    border: {
      radius: '26px',
      color: '#2E4787',
      width: '1px',
    },

    extend: props => {
      let {
        hideBorder,
        theme: {
          global: {
            colors: { brand, cornflowerBlue },
            colors,
          },
        },
        hoverBackground,
        background,
        fontSize = '16px',
        signInButton,
      } = props
      hoverBackground = !hideBorder
        ? hoverBackground || brand
        : colors[hoverBackground] || hoverBackground || cornflowerBlue
      background = `${
        background ? `background:${colors[background] || background}` : ''
      }`
      return `
        ${background};
        font-size: ${fontSize};
        ${signInButton
          && `&:hover{background: ${hoverBackground || '#2E4787'};
        color:   "#fff";
       ;
      }`}`
    },
    padding: {
      vertical: '12px',
      horizontal: '24px',
    },
  },
}

export const getSuggestedAddressText = (
  address,
  shipment,
  hideName = false,
) => {
  const name = hideName
    ? ''
    : `${shipment.deliveryFirstName} ${shipment.deliveryLastName}`
  return `${name} ${address.delivery_street_address} ${address.delivery_city} ${
    address.delivery_state
  } ${address.delivery_postcode} ${shipment.deliveryCountry}`
}

export const getLocalAddressText = shipment => `${shipment.deliveryFirstName} ${shipment.deliveryLastName} ${
  shipment.deliveryStreetAddress
} ${shipment.deliveryCity} ${shipment.deliveryState} ${
  shipment.deliveryPostcode
} ${shipment.deliveryCountry}`

export const commaSeparetedValue = (value, fraction = 2) => parseFloat(value)
  .toLocaleString(undefined, {
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction,
  })

export const promisify = fn => function promisifyFn() {
  return new Promise((resolve, reject) => {
    fn(...arguments, (err, data) => (err ? reject(err) : resolve(data)))
  })
}

export const isAddressSame = (customer, shipment) => {
  const fields = [
    'StreetAddress',
    'SuburbAddress',
    'City',
    'State',
    'Country',
    'Telephone',
  ]
  const isExact = fields.reduce((exact, field) => exact && customer[`customer${field}`] === shipment[`delivery${field}`],
    true)

  return (
    isExact
    && (shipment.deliveryName
      || `${shipment.deliveryFirstName} ${shipment.deliveryLastName}`)
      === `${customer.customerFirstName} ${customer.customerLastName}`
  )
}
